import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { downloadFile } from 'actions/chat';
import FileMessage from 'components/chat/fileUpload/FileMessage';

export default connect(
  () => ({}),
  (dispatch, ownProps) => bindActionCreators({
    onDownload: downloadFile.bind(null, ownProps.guid, ownProps.fileName)
  }, dispatch)
)(FileMessage);



// WEBPACK FOOTER //
// ./containers/chat/fileUpload/FileMessage.js